import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../static/logos/logo.PNG";

import cart from "../static/cart.svg";
import phone from "../static/phone.png";
import { useSelector, useDispatch } from "react-redux";
import SearchAutoComplete from "./SearchAutoComplete";
import { Col, Row } from "react-bootstrap";
import shape from "../static/shape.svg";
import UserDropDown from "./Header/UserDropDown";
import OutletSelector from "./Header/OutletSelector";
import OutletSelectorM from "./Header/OutletSelectorM";
import { getAllOutlets } from "../services/OutletService";
import { UpdatePatientProfile } from "../services/UserService";
import { getLocalData, setLocalData } from "../utils/localStorage";
import { updateUser } from "../redux/userSlice";

import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { Divide as Hamburger } from "hamburger-react";
import SearchAutoCompleteM from "./SearchAutoCompleteM";
import { updateOutletId } from "../redux/outletSlice";
import Wishlist from "./SvgComponents/Wishlist";
import User from "./SvgComponents/User";
import Cart from "./SvgComponents/Cart";
function Header() {
  let location = useLocation();
  const navigate = useNavigate();
  const [fix, setFix] = useState(false);
  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {}, [location]);

  const noOfProductsInWishlist = useSelector(
    (state) => state.cart.noOfProductsInWishList
  );
  const noOfProductsInCart = useSelector(
    (state) => state.cart.noOfProductsInCart
  );

  const changeBackground = () => {
    if (window.scrollY >= height) {
      setFix(true);
    } else {
      setFix(false);
    }
  };

  useEffect(() => {
    if (location.pathname === "/") {
      changeBackground();
      // adding the event when scroll change background
      window.addEventListener("scroll", changeBackground);
    } else {
      setFix((fix) => true);
    }

    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  });

  useEffect(() => {
    if (location.pathname === "/") {
      setHeight(ref.current.clientHeight);
    } else {
      setFix(true);
    }
  }, [location]);

  const [outlet, setoutlet] = useState(null);
  const [options, setOptions] = React.useState([]);
  const userData = useSelector((state) => state.user.userData);


  const userTokenMain = getLocalData("user-info")?.userToken

  //get all the outlets from origin
  useEffect(() => {
    getAllOutlets()
      .then((data) => {
        setOptions(data);
      })
      .catch((err) => console.log(err));
  }, [userTokenMain]);

  const dispatch = useDispatch();

  //set outlet id when load
  useEffect(() => {
    if (options.length > 0) {
      var userTOken = getLocalData("user-info")?.userToken;

      if (userTOken) {
        if (userData.outletId > 0) {
          let tempArr = options.find(
            (outlet) => outlet.id === userData.outletId
          );
          setLocalData("outlet-id", tempArr.id);
          
          if (tempArr) {
            setoutlet(tempArr);
          }
        } else if (userData.outletId <= 0) {
          let tempArr = options.find((outlet) => outlet.isDefault === true);
          dispatch(updateOutletId(tempArr.id));
          if (tempArr) {
            setoutlet(tempArr);
          }
        }
      } else {
      
        let tempArr = options.find((outlet) => outlet.isDefault === true);
        setLocalData("outlet-id", tempArr.id);
        
        if (tempArr) {
          setoutlet(tempArr);
        }
      }
    }
  }, [options]);

  //when changing the outlet id for a logged in user
  useEffect(() => {
    if (JSON.stringify(userData) !== "{}") {
      if (outlet) {
        if (outlet.id !== userData.outletId) {
          var tempUser = {
            ...userData,
            outletId: outlet.id,
          };
          var tempTOken = getLocalData("user-info")?.userToken;
          UpdatePatientProfile(tempUser, tempTOken)
            .then((data) => {
              if (data.status === "Success") {
                let tempObj = {
                  userData: data.response.patientData,
                  userToken: tempTOken,
                };
                setLocalData("user-info", tempObj);
                dispatch(updateUser(data.response.patientData));
                setLocalData("outlet-id", outlet.id);
                
              }
            })
            .catch((err) => console.log(err));
        }
      }
    }
  }, [outlet]);

  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    if (getLocalData("user-info")?.userToken?.length > 0) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
    //console.log("data changed" + loggedIn);
  }, [getLocalData("user-info")?.userToken]);

  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);

    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimenion]);

  const [drawerState, setDrawerState] = useState(false);

  const [focusSearch, setFocusSearch] = useState(false);
  const [focusOutletSel, setFocusOutletSel] = useState(false);

  return (
    <>
      {fix &&  windowDimenion.winWidth > 787  && (
        <div
          className={`header-main ${fix ? '': 'v-h-none'}`}
        >
          <div className="container">
            <div className=" header-parent">
              <div className="header-logo">
                <Link to="/">
                  <img alt="logo" className="img-fluid logoheader" src={logo} />
                </Link>
              </div>
              <div className="header-input">
                <div className="big-input">
                  <Row>
                    <Col md={5}>
                      <OutletSelector
                        options={options}
                        setoutlet={setoutlet}
                        outlet={outlet}
                      />
                    </Col>
                    <Col md={7}>
                      <SearchAutoComplete />
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="header-buttons">
                <UserDropDown />
                {loggedIn ? (
                  <>
                    <Link to="/wishlist" className="round-btn-header">
                    <Wishlist />
                    </Link>
                    <Link to="/cart" className="round-btn-header">
                      
                      <Cart/>
                      {noOfProductsInCart > 0 && (
                        <span className="counter">{noOfProductsInCart}</span>
                      )}
                    </Link>
                  </>
                ) : (
                  <>
                    <Link to="/login" className="round-btn-header">
                    <Wishlist />
                    </Link>
                    <Link to="/login" className="round-btn-header">
                    <Cart/>
                    </Link>
                  </>
                )}
              </div>
              <div className="header-navbar">
                <ul className="hlinks">
                  <li>
                    <Link
                      className={`header-text ${
                        location.pathname === "/categories" ? "active" : ""
                      }`}
                      to="/categories"
                    >
                      Categories
                    </Link>
                  </li>
                  {/* <li>
                    <a className="header-text" href="/">
                      Deals
                    </a>
                  </li> */}
                  <li>
                    <Link
                      className={`header-text ${
                        location.pathname === "/brands" ? "active" : ""
                      }`}
                      to="/brands"
                    >
                      Brands
                    </Link>
                  </li>
                  <li>
                  <Link
                      className={`header-text ${
                        location.pathname === "/allofferrproducts" ? "active" : ""
                      }`}
                      to="/allofferrproducts"
                    >
                      Offers
                    </Link>
                  </li>
                  <li>
                    
                    <Link
                      className={`header-text ${
                        location.pathname === "/featuredproducts" ? "active" : ""
                      }`}
                      to="/featuredproducts"
                    >
                      Featured Products
                    </Link>
                  </li>
                  {/* <li>
                    <a className="header-text" href="/">
                      Stores
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}

      {location.pathname === "/" && (
        
        <section
          className={`home-hero ${
            windowDimenion.winWidth <= 787 ? "p-0" : ""
          }`}
          ref={ref}
        >
          {
             windowDimenion.winWidth > 787 && (
              <div className="container">
              <div className=" header-parent-hero">
                <div className="header-logo-hero">
                  <Link to="/">
                    <img
                      alt="logo"
                      className="img-fluid logoheader log-main"
                      src={logo}
                    />
                  </Link>
                </div>
                <div className="header-input-hero">
                  <div className="big-input">
                    <Row>
                      <Col md={5}>
                        <OutletSelector
                          options={options}
                          setoutlet={setoutlet}
                          outlet={outlet}
                        />
                      </Col>
                      <Col md={7}>
                        <SearchAutoComplete height={height} />
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="header-buttons-hero">
                  
                  <UserDropDown />
                  {loggedIn ? (
                    <>
                      <Link to="/wishlist" className="round-btn-header">
                        
                        <Wishlist />
                      </Link>
                      <Link to="/cart" className="round-btn-header">
                      <Cart/>
                        {noOfProductsInCart > 0 && (
                          <span className="counter">{noOfProductsInCart}</span>
                        )}
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link to="/login" className="round-btn-header">
                      <Wishlist />
                      </Link>
                      <Link to="/login" className="round-btn-header">
                      <Cart/>
                      </Link>
                    </>
                  )}
                </div>
  
                <div className="header-buttons-download-hero">
                  <a href="#download-apps" className="hero-h-download-btn btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22" fill="none">
  <path d="M11 0H3C1.34 0 0 1.34 0 3V19C0 20.66 1.34 22 3 22H11C12.66 22 14 20.66 14 19V3C14 1.34 12.66 0 11 0ZM12 17H2V3H12V17ZM9 20H5V19H9V20Z" fill="white"/>
  </svg>
                    <span> get the app</span>
                  </a>
                </div>
  
                <div className="header-navbar-hero">
                  <ul className="hlinks">
                    <li>
                      <Link
                        className={`header-text ${
                          location.pathname === "/categories" ? "active" : ""
                        }`}
                        to="/categories"
                      >
                        Categories
                      </Link>
                    </li>
                    {/* <li>
                      <a className="header-text" href="/">
                        Deals
                      </a>
                    </li> */}
                    <li>
                      <Link
                        className={`header-text ${
                          location.pathname === "/brands" ? "active" : ""
                        }`}
                        to="/brands"
                      >
                        Brands
                      </Link>
                    </li>
                    <li>
                    <Link
                        className={`header-text ${
                          location.pathname === "/allofferrproducts" ? "active" : ""
                        }`}
                        to="/allofferrproducts"
                      >
                        Offers
                      </Link>
                    </li>
                    <li>
                    <Link
                        className={`header-text ${
                          location.pathname === "/featuredproducts" ? "active" : ""
                        }`}
                        to="/featuredproducts"
                      >
                        Featured Products
                      </Link>
                    </li>
                    {/* <li>
                      <a className="header-text" href="/">
                        Stores
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
             )
          }
         
         
        </section>
      )}

      {windowDimenion.winWidth <= 787 && (
        <>
          <div className="mobile-header">
            <div className="mg-btn">
              <Hamburger
                color="#222222"
                size={25}
                toggled={drawerState}
                onToggle={(toggled) => {
                  if (toggled) {
                    setDrawerState(true);
                  } else {
                    setDrawerState(false);
                  }
                }}
              />
            </div>
            <div className="mg-logo">
              <Link
                to="/"
                onClick={() => {
                  setDrawerState(false);
                }}
              >
                <img alt="logo" className="img-fluid logoheader" src={logo} />
              </Link>
            </div>
            <div className="mg-user">
              {loggedIn ? (
                <>
                  <Link
                    to="/user"
                    className="round-btn-header"
                    onClick={() => {
                      setDrawerState(false);
                    }}
                  >
                    <User/>
                  </Link>
                  <Link
                    to="/wishlist"
                    className="round-btn-header"
                    onClick={() => {
                      setDrawerState(false);
                    }}
                  >
                    <Wishlist />
                  </Link>
                  <Link
                    to="/cart"
                    className="round-btn-header"
                    onClick={() => {
                      setDrawerState(false);
                    }}
                  >
                     <Cart/>
                    {noOfProductsInCart > 0 && (
                      <span className="counter">{noOfProductsInCart}</span>
                    )}
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="round-btn-header"
                    onClick={() => {
                      setDrawerState(false);
                    }}
                  >
                   <User/>
                  </Link>
                  <Link
                    to="/login"
                    className="round-btn-header"
                    onClick={() => {
                      setDrawerState(false);
                    }}
                  >
                    <Wishlist />
                  </Link>
                  <Link
                    to="/login"
                    className="round-btn-header"
                    onClick={() => {
                      setDrawerState(false);
                    }}
                  >
                     <Cart/>
                  </Link>
                </>
              )}
            </div>
            <div className="mg-srch">
              <div className="big-input">
                <Row>
                  <Col
                    xs={focusOutletSel ? 12 : 5}
                    className={`${focusSearch ? "d-none" : ""}`}
                  >
                    <OutletSelectorM
                      options={options}
                      setoutlet={setoutlet}
                      outlet={outlet}
                      setFocusOutletSel={setFocusOutletSel}
                    />
                  </Col>
                  <Col
                    xs={focusSearch ? 12 : 7}
                    className={`${focusOutletSel ? "d-none" : ""}`}
                  >
                    <SearchAutoCompleteM setFocusSearch={setFocusSearch} />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <SwipeableDrawer
            anchor={"left"}
            open={drawerState}
            onClose={() => {
              setDrawerState(false);
            }}
            onOpen={() => {
              setDrawerState(true);
            }}
          >
            <div className="drawer-parent">
              <div className="drawer-sec">
                <Col xs={12}>
                  <Link
                    onClick={() => {
                      setDrawerState(false);
                    }}
                    className={`header-text ${
                      location.pathname === "/" ? "active" : ""
                    }`}
                    to="/"
                  >
                    Home
                  </Link>
                </Col>
                <Col xs={12}>
                  <Link
                    onClick={() => {
                      setDrawerState(false);
                    }}
                    className={`header-text ${
                      location.pathname === "/categories" ? "active" : ""
                    }`}
                    to="/categories"
                  >
                    Categories
                  </Link>
                </Col>
                {/* <Col xs={12}>
                  <a
                    className="header-text"
                    href="/"
                    onClick={() => {
                      setDrawerState(false);
                    }}
                  >
                    Deals
                  </a>
                </Col> */}
                <Col xs={12}>
                  <Link
                    onClick={() => {
                      setDrawerState(false);
                    }}
                    className={`header-text ${
                      location.pathname === "/brands" ? "active" : ""
                    }`}
                    to="/brands"
                  >
                    Brands
                  </Link>
                </Col>
                <Col xs={12}>
                <Link
                    onClick={() => {
                      setDrawerState(false);
                    }}
                    className={`header-text ${
                      location.pathname === "/featuredproducts" ? "active" : ""
                    }`}
                    to="/allofferrproducts"
                  >
                    Offers
                  </Link>
                </Col>
                <Col xs={12}>
                <Link
                    onClick={() => {
                      setDrawerState(false);
                    }}
                    className={`header-text ${
                      location.pathname === "/featuredproducts" ? "active" : ""
                    }`}
                    to="/featuredproducts"
                  >
                    Featured Products
                  </Link>
                </Col>
                {/* <Col xs={12}>
                  <a
                    onClick={() => {
                      setDrawerState(false);
                    }}
                    className="header-text"
                    href="/"
                  >
                    Stores
                  </a>
                </Col> */}
              </div>
              <div className="drawer-logout">
                {JSON.stringify(userData) !== "{}" && (
                  <button
                    className="btn btn-danger btn-logout user-profile-logout"
                    onClick={() => {
                      localStorage.clear();
                      dispatch(updateUser({}));
                      navigate("/");
                    }}
                  >
                    LOGOUT
                  </button>
                )}
              </div>
            </div>
          </SwipeableDrawer>
        </>
      )}
    </>
  );
}

export default Header;
